'use client';

import { TFormType } from '@/components/buttons/AuthButton';
import { MobileLoginForm } from './MobileLoginForm';
import { MobileRegisterForm } from './MobileRegisterForm';
import { MobileProfileOptions } from './MobileProfileOptions';
import { useSession } from 'next-auth/react';

interface IProfileModalContentProps {
  formType: TFormType;
  switchForm: () => void;
  handleClose: () => void;
}

export const ProfileModalContent = ({ formType, switchForm, handleClose }: IProfileModalContentProps) => {
  const session = useSession();

  if (!!session.data) return <MobileProfileOptions handleClose={handleClose} />;
  if (formType === 'login') return <MobileLoginForm switchForm={switchForm} handleClose={handleClose} />;
  return <MobileRegisterForm switchForm={switchForm} handleClose={handleClose} />;
};
